if (!customElements.get('product-gallery')) {
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    init() {
      const closeIcon = this.querySelector('[data-close-icon]');
      const prevIcon = this.querySelector('[data-prev-icon]');
      const nextIcon = this.querySelector('[data-next-icon]');

      function isPhone() {
        return window.innerWidth < 750;
      }

      const lightbox = new PhotoSwipeLightbox({
        gallery: this,
        children: '.product-media-grid__link[data-pswp-image], .product-media-grid__link[data-pswp-type="html"]',
        mainClass: 'pswp--product-media-gallery',
        loop: false,
        showHideAnimationType: 'zoom',
        initialZoomLevel: zoomLevelObject => (isPhone() ? zoomLevelObject.vFill : zoomLevelObject.fit),
        secondaryZoomLevel: zoomLevelObject => (isPhone() ? zoomLevelObject.fit : 1),
        pswpModule: PhotoSwipe
      });

      lightbox.addFilter('uiElement', (element, data) => {
        if (data.name === 'close' && closeIcon) {
          element.innerHTML = closeIcon.innerHTML;
        } else if (data.name === 'arrowPrev' && prevIcon) {
          element.innerHTML = prevIcon.innerHTML;
        } else if (data.name === 'arrowNext' && nextIcon) {
          element.innerHTML = nextIcon.innerHTML;
        }
        return element;
      });

      lightbox.addFilter('itemData', (itemData, index) => {
        if (itemData.type === 'html' && itemData.element) {
          return { html: itemData.element.dataset.pswpHtml };
        }
        return itemData;
      });

      lightbox.init();
      this.lightbox = lightbox;

      this.addEventListener('dragstart', event => event.preventDefault());
    }

    setActiveMedia(id) {
      const target = Array.from(this.querySelectorAll('[data-media-id]')).find(
        media => Number(media.dataset.mediaId) === Number(id)
      );
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  customElements.define('product-gallery', ProductGallery);
}
